import { Dispatch, SetStateAction, useState } from "react";
import AdminModal from "../../../../core/admin/adminModal";
import AdminButton from "../../../../core/admin/adminButton";
import { useWatches } from "../../../../../context/watchProvider";
import AdminToast from "../../../../core/admin/adminToast";
import AdminTabs from "../../../../core/admin/adminTabs";
import AdminField, { AdminSelect, AdminTextarea } from "../../../../core/admin/adminField";
import AdminTextInput from "../../../../core/admin/adminTextInput";
import AdminCallout from "../../../../core/admin/adminCallout";
import AdminEmptyState from "../../../../core/admin/adminEmptyState";
import { AdminLoading } from "../../../../core/admin/adminSpinner";
import { CheckLineIcon, PencilIcon, SortIcon } from "../../../../../img/svg/adminIcons";
import { braceletMaterialFields, caseMaterialFields, functionsFields, glassFields, movementFields, stateFields } from "../../../../../utils/fields";
import { IWatch } from "../../watches/adminWatches";
import { countWatchInfos, getWatchPendencies, WATCH_INFOS_TOTAL } from "../../../../../utils/watchCompleteness";
import ImagesUploader from "./imagesUploader";
import ImagesReorderer from "./imagesReorderer";

export default function EditDraftModal({ close, watch, setWatch, finish, refresh }: { close: () => void, watch: IWatch | null, setWatch: Dispatch<SetStateAction<IWatch | null>>, finish: () => void, refresh: () => void }) {

    const { updateWatch, getWatch } = useWatches();

    const [tab, setTab] = useState(0);
    const [badToast, setBadToast] = useState(false);
    const [editGeneral, setEditGeneral] = useState(false);
    const [loading, setLoading] = useState(false);
    const [reorder, setReorder] = useState(false);
    const [saving, setSaving] = useState(false);

    const [brand, setBrand] = useState(watch?.brand || "");
    const [model, setModel] = useState(watch?.model || "");
    const [year, setYear] = useState(watch?.year || "");

    const [serial, setSerial] = useState(watch?.serial || ""); // serial
    const [state, setState] = useState(watch?.state || ""); // estado - select
    // const [functions, setFunctions] = useState(watch?.functions || ""); // funções - checkboxes
    const [functions, setFunctions] = useState(watch?.functions || []); // funções - checkboxes
    const [movement, setMovement] = useState(watch?.movement || ""); // movimento - select
    const [movementModel, setMovementModel] = useState(watch?.movementModel || ""); // modelo movimento - text
    const [braceletMaterial, setBraceletMaterial] = useState(watch?.braceletMaterial || ""); // material do bracelete - select
    const [caseMaterial, setCaseMaterial] = useState(watch?.caseMaterial || ""); // material da caixa - select
    const [diameter, setDiameter] = useState(watch?.diameter || null); // diametro - number
    const [tightness, setTightness] = useState(watch?.tightness || null); // estanqueidade - number
    const [glass, setGlass] = useState(watch?.glass || ""); // vidro - select
    const [content, setContent] = useState(watch?.content || ""); // conteudo fornecido - text
    const [price, setPrice] = useState(watch?.price || null); // preço - number
    const [description, setDescription] = useState(watch?.description || ""); // outras caracteristicas - text
    const [boxAndDocuments, setBoxAndDocuments] = useState<boolean | null>(watch?.boxAndDocuments);
    const [original, setOriginal] = useState(watch?.original || false);

    const doUpdateWatch = async () => {
        if (!watch?.id) {
            return null
        }
        const wtc = await getWatch(watch.id);
        setWatch(wtc);
        setReorder(false);
    }

    const updateInfos = async () => {
        if (!watch?.id || !serial || !state || !functions || !movement ||
            !braceletMaterial || !caseMaterial ||
            !diameter || !tightness || !glass ||
            !price || boxAndDocuments === null || !original
        ) {
            return null
        }
        const update = await updateWatch(watch.id, {
            serial,
            state,
            functions,
            movement,
            movementModel,
            braceletMaterial,
            caseMaterial,
            diameter: parseInt(diameter),
            tightness: parseInt(tightness),
            glass,
            content,
            price: parseFloat(price),
            description,
            boxAndDocuments: boxAndDocuments,
            original
        });
        if (update) {
            finish();
        }
        setBadToast(true);
    }

    const handleYear = (value: string) => {
        if (value === "") {
            setYear("");
            return null;
        }
        if (!/^\d+$/.test(value)) {
            return null;
        }
        setYear(value);
    }
    const handleDiameter = (value: string) => {
        if (value === "") {
            setDiameter("");
            return null;
        }
        if (!/^\d+$/.test(value)) {
            return null;
        }
        setDiameter(value);
    }
    const handleTightness = (value: string) => {
        if (value === "") {
            setTightness("");
            return null;
        }
        if (!/^\d+$/.test(value)) {
            return null;
        }
        setTightness(value);
    }
    const handlePrice = (value: string) => {
        // 1. Remove tudo que não for dígito
        const digits = value.replace(/\D/g, "");

        if (digits === "") {
            setPrice("");
            return;
        }

        // 2. Transforma em centavos (ex: "1250" vira 12.50)
        const numericValue = (Number(digits) / 100).toFixed(2);

        // 3. Atualiza o estado com o valor numérico em string (ex: "12.50")
        setPrice(numericValue);
    };

    const sendToApproval = async () => {
        if (!watch?.id || pendencies.length) {
            return null;
        }
        const update = await updateWatch(watch.id, { status: "approval" });
        if (update) {
            finish();
        }
    }

    const updateGeneralInfo = async () => {
        setLoading(true);
        try {
            if (!watch?.id) {
                setLoading(false);
                return null;
            }
            const response = await updateWatch(watch.id, { brand, model, year: parseInt(year) });
            if (!response) {
                setBadToast(true);
                setLoading(false);
                return null;
            }
            finish();
        } catch (error) {
            setLoading(false);
            setBadToast(true);
            console.log(error);
        }
    }

    const handleDescription = (value: string) => {
        if (value.length > 422) {
            return null;
        }
        setDescription(value);
    }

    const handleBoxAndDocs = (value: string) => {
        if (value === "sim") {
            setBoxAndDocuments(true);
            return null;
        } if (value === "nao") {
            setBoxAndDocuments(false);
            return null;
        }
        setBoxAndDocuments(null);
    }

    const handleFunctions = (f: string) => {
        if (functions.includes(f)) {
            setFunctions(functions.filter((item: string) => item !== f));
        } else {
            setFunctions([...functions, f]);
        }
    }

    const isSaveButtonDisabled =
        (state === watch?.state &&
            serial === watch?.serial &&
            functions === watch?.functions &&
            movement === watch?.movement &&
            movementModel === watch?.movementModel &&
            braceletMaterial === watch?.braceletMaterial &&
            caseMaterial === watch?.caseMaterial &&
            diameter === watch?.diameter &&
            tightness === watch?.tightness &&
            glass === watch?.glass &&
            content === watch?.content &&
            price === watch?.price &&
            description === watch?.description &&
            boxAndDocuments === watch?.boxAndDocuments &&
            original === watch?.original) ||
        serial === "" ||
        state === "" ||
        functions === "" ||
        movement === "" ||
        braceletMaterial === "" ||
        caseMaterial === "" ||
        diameter === "" ||
        tightness === "" ||
        glass === "" ||
        price === "" ||
        boxAndDocuments === null ||
        !original;

    const propsCount = countWatchInfos(watch);
    // mesma regra que o admin precisa cumprir para publicar (watchModal.tsx)
    const pendencies = getWatchPendencies(watch);

    const imagesCount = watch?.images?.length || 0;

    // envolve as ações dos rodapés para exibir carregamento no botão
    const run = async (action: () => Promise<any>) => {
        setSaving(true);
        await action();
        setSaving(false);
    }

    return (
        <AdminModal
            close={refresh}
            size="lg"
            title={`${watch?.brand || ""} ${watch?.model || ""}`}
            subtitle={`Rascunho · Ano ${watch?.year || "—"}`}
            tabs={
                <AdminTabs
                    value={tab}
                    onChange={setTab}
                    tabs={[
                        { value: 0, label: "Geral" },
                        { value: 1, label: <>Informações <span className="text-xs font-normal text-gray-400">{propsCount}/{WATCH_INFOS_TOTAL}</span></> },
                        { value: 2, label: "Imagens", count: imagesCount },
                        { value: 3, label: "Comentários", alert: !!watch?.comment },
                    ]}
                />
            }
            footer={
                tab === 0 ?
                    <AdminButton loading={saving} onClick={() => run(sendToApproval)} disabled={pendencies.length > 0}>Enviar para aprovação</AdminButton>
                    : tab === 1 ?
                        <AdminButton loading={saving} onClick={() => run(updateInfos)} disabled={isSaveButtonDisabled} className="sm:min-w-[120px]">Salvar</AdminButton>
                        : undefined
            }
        >
            {
                tab === 0 ?
                    <div className="flex flex-col gap-6">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <ProgressCard label="Informações preenchidas" current={propsCount} total={WATCH_INFOS_TOTAL} />
                            <ProgressCard label="Nº de imagens" current={imagesCount} total={5} />
                        </div>
                        {
                            pendencies.length ?
                                <AdminCallout tone="info" title="Para enviar para aprovação, falta:">
                                    <ul className="list-disc pl-5">
                                        {
                                            pendencies.map(p => <li key={p}>{p}</li>)
                                        }
                                    </ul>
                                </AdminCallout>
                                : <AdminCallout tone="success">Tudo pronto! Você já pode enviar este relógio para aprovação.</AdminCallout>
                        }
                        <section className="rounded-xl border border-gray-200 p-4">
                            <div className="flex items-center justify-between gap-3 mb-4">
                                <h3 className="font-bold text-gray-900">Dados gerais</h3>
                                {
                                    !editGeneral && !loading ?
                                        <AdminButton size="sm" variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => setEditGeneral(true)}>Editar</AdminButton>
                                        : null
                                }
                            </div>
                            {
                                loading ?
                                    <AdminLoading />
                                    :
                                    <div className="flex flex-col gap-4">
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            <AdminField label="Marca" htmlFor="edit-brand">
                                                <AdminTextInput id="edit-brand" value={brand} onChange={e => setBrand(e.target.value)} disabled={!editGeneral} />
                                            </AdminField>
                                            <AdminField label="Modelo" htmlFor="edit-model">
                                                <AdminTextInput id="edit-model" value={model} onChange={e => setModel(e.target.value)} disabled={!editGeneral} />
                                            </AdminField>
                                            <AdminField label="Ano" htmlFor="edit-year">
                                                <AdminTextInput id="edit-year" inputMode="numeric" value={year} onChange={e => handleYear(e.target.value)} disabled={!editGeneral} />
                                            </AdminField>
                                        </div>
                                        {
                                            editGeneral ?
                                                <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
                                                    <AdminButton variant="secondary" onClick={() => setEditGeneral(false)}>Cancelar</AdminButton>
                                                    <AdminButton onClick={updateGeneralInfo}>Salvar</AdminButton>
                                                </div>
                                                : null
                                        }
                                    </div>
                            }
                        </section>
                    </div>
                    : tab === 1 ?
                        <div className="flex flex-col gap-5">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {/* Serial */}
                                <AdminField label="Serial" htmlFor="edit-serial" required>
                                    <AdminTextInput id="edit-serial" value={serial} onChange={e => setSerial(e.target.value.toUpperCase())} />
                                </AdminField>
                                {/* Estado */}
                                <AdminField label="Estado" htmlFor="edit-state" required>
                                    <AdminSelect id="edit-state" value={state} onChange={e => setState(e.target.value)}>
                                        <option value="">-</option>
                                        {
                                            Object.keys(stateFields).map((k, i) => (
                                                <option key={i} value={k}>{stateFields[k]}</option>
                                            ))
                                        }
                                    </AdminSelect>
                                </AdminField>
                                {/* Funções */}
                                <AdminField label="Funções" required className="md:col-span-2">
                                    <div className="flex flex-wrap gap-2">
                                        {
                                            Object.keys(functionsFields)?.map((f, i) => {
                                                const checked = functions.includes(f);
                                                return (
                                                    <label key={i} htmlFor={`fn-${f}`} className={`inline-flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-semibold transition select-none ${checked ? "border-gray-900 bg-gray-900 text-white" : "border-gray-300 bg-white text-gray-700 hover:border-gray-400"}`}>
                                                        <input type="checkbox" value={f} id={`fn-${f}`} checked={checked} onChange={e => handleFunctions(e.target.value)} className="sr-only" />
                                                        {
                                                            checked ?
                                                                <CheckLineIcon width="14px" />
                                                                : null
                                                        }
                                                        {functionsFields[f]}
                                                    </label>
                                                )
                                            })
                                        }
                                    </div>
                                </AdminField>
                                {/* movimento - select */}
                                <AdminField label="Movimento" htmlFor="edit-movement" required>
                                    <AdminSelect id="edit-movement" value={movement} onChange={e => setMovement(e.target.value)}>
                                        <option value="">-</option>
                                        {
                                            Object.keys(movementFields).map((k, i) => (
                                                <option key={i} value={k}>{movementFields[k]}</option>
                                            ))
                                        }
                                    </AdminSelect>
                                </AdminField>
                                {/* modelo do movimento - text */}
                                <AdminField label="Modelo do Movimento" htmlFor="edit-movement-model">
                                    <AdminTextInput id="edit-movement-model" value={movementModel} onChange={e => setMovementModel(e.target.value)} placeholder="Modelo do Movimento" />
                                </AdminField>
                                {/* material do bracelete - select */}
                                <AdminField label="Material do Bracelete" htmlFor="edit-bracelet" required>
                                    <AdminSelect id="edit-bracelet" value={braceletMaterial} onChange={e => setBraceletMaterial(e.target.value)}>
                                        <option value="">-</option>
                                        {
                                            Object.keys(braceletMaterialFields).map((k, i) => (
                                                <option key={i} value={k}>{braceletMaterialFields[k]}</option>
                                            ))
                                        }
                                    </AdminSelect>
                                </AdminField>
                                {/* material da caixa - select */}
                                <AdminField label="Material da Caixa" htmlFor="edit-case" required>
                                    <AdminSelect id="edit-case" value={caseMaterial} onChange={e => setCaseMaterial(e.target.value)}>
                                        <option value="">-</option>
                                        {
                                            Object.keys(caseMaterialFields).map((k, i) => (
                                                <option key={i} value={k}>{caseMaterialFields[k]}</option>
                                            ))
                                        }
                                    </AdminSelect>
                                </AdminField>
                                {/* diametro - number */}
                                <AdminField label="Diâmetro (mm)" htmlFor="edit-diameter" required>
                                    <AdminTextInput id="edit-diameter" inputMode="numeric" value={diameter || ""} onChange={e => handleDiameter(e.target.value)} />
                                </AdminField>
                                {/* estanqueidade - number */}
                                <AdminField label="Estanqueidade (ATM)" htmlFor="edit-tightness" required>
                                    <AdminTextInput id="edit-tightness" inputMode="numeric" value={tightness || ""} onChange={e => handleTightness(e.target.value)} />
                                </AdminField>
                                {/* vidro - select */}
                                <AdminField label="Vidro" htmlFor="edit-glass" required>
                                    <AdminSelect id="edit-glass" value={glass} onChange={e => setGlass(e.target.value)}>
                                        <option value="">-</option>
                                        {
                                            Object.keys(glassFields).map((k, i) => (
                                                <option key={i} value={k}>{glassFields[k]}</option>
                                            ))
                                        }
                                    </AdminSelect>
                                </AdminField>
                                {/* possui caixa e documentos originais - boolean */}
                                <AdminField label="Caixa e documentos originais" htmlFor="edit-box" required>
                                    <AdminSelect id="edit-box" value={boxAndDocuments ? "sim" : boxAndDocuments === false ? "nao" : ""} onChange={e => handleBoxAndDocs(e.target.value)}>
                                        <option value="" hidden>-</option>
                                        <option value="sim">Sim</option>
                                        <option value="nao">Não</option>
                                    </AdminSelect>
                                </AdminField>
                                {/* conteudo fornecido - text */}
                                <AdminField label="Conteúdo adicional" htmlFor="edit-content">
                                    <AdminTextInput id="edit-content" value={content} onChange={e => setContent(e.target.value)} placeholder="Conteúdo adicional" />
                                </AdminField>
                                {/* preço - number */}
                                <AdminField label="Preço (R$)" htmlFor="edit-price" required>
                                    <AdminTextInput
                                        id="edit-price"
                                        inputMode="numeric"
                                        value={price ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(price)) : ""}
                                        onChange={(e) => handlePrice(e.target.value)}
                                        placeholder="R$ 0,00"
                                    />
                                </AdminField>
                                {/* descrição - text */}
                                <AdminField label="Descrição" htmlFor="edit-description" className="md:col-span-2" counter={{ current: description.length, max: 422 }}>
                                    <AdminTextarea id="edit-description" value={description} onChange={e => handleDescription(e.target.value)} />
                                </AdminField>
                            </div>
                            <label htmlFor="draft-original" className={`flex cursor-pointer items-start gap-3 rounded-xl border p-4 transition ${original ? "border-emerald-300 bg-emerald-50" : "border-gray-200 hover:border-gray-300"}`}>
                                <input id="draft-original" type="checkbox" className="mt-0.5 h-4 w-4 accent-gray-900" checked={original} onChange={e => setOriginal(!original)} />
                                <span className="text-sm font-semibold text-gray-800">Declaro que sou responsável pela autenticidade do produto.<span className="text-red-600 ml-0.5">*</span></span>
                            </label>
                            <p className="text-xs text-gray-500"><span className="text-red-600">*</span> informações obrigatórias</p>
                        </div>
                        : tab === 2 ?
                            <div className="flex flex-col gap-4">
                                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3">
                                    <div>
                                        <h3 className="font-bold text-gray-900">Upload de imagens</h3>
                                        <p className="text-sm text-gray-500">A ordem aqui determinada será a ordem de exibição. Até 5 imagens, apenas <strong>menores que 5MB</strong>.</p>
                                    </div>
                                    {
                                        !reorder ?
                                            <AdminButton size="sm" variant="secondary" icon={<SortIcon width="14px" />} disabled={!imagesCount} onClick={() => setReorder(true)}>Reordenar</AdminButton>
                                            :
                                            <AdminButton size="sm" variant="secondary" onClick={() => setReorder(false)}>Cancelar</AdminButton>
                                    }
                                </div>
                                {
                                    reorder ?
                                        <ImagesReorderer watch={watch} setWatch={setWatch} update={doUpdateWatch} />
                                        :
                                        <ImagesUploader watch={watch} update={doUpdateWatch} />
                                }
                            </div>
                            : tab === 3 ?
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-3">Comentários do administrador</h3>
                                    {
                                        watch?.comment ?
                                            <AdminCallout tone="warning">
                                                <p className="whitespace-pre-line break-words">{watch?.comment}</p>
                                            </AdminCallout>
                                            : <AdminEmptyState title="Nenhum comentário" description="Se a equipe pedir alguma alteração, o comentário aparece aqui." />
                                    }
                                </div>
                                : null
            }
            <AdminToast toast={badToast} setToast={setBadToast} message="Algo deu errado" tone="danger" />
        </AdminModal>
    )
}

function ProgressCard({ label, current, total }: { label: string, current: number, total: number }) {
    const percent = Math.min(100, Math.round((current / total) * 100));
    return (
        <div className="rounded-xl border border-gray-200 p-4">
            <div className="flex items-baseline justify-between gap-2">
                <p className="text-sm font-semibold text-gray-700">{label}</p>
                <p className="text-lg font-bold tabular-nums text-gray-900">{current}<span className="text-sm font-semibold text-gray-400">/{total}</span></p>
            </div>
            <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
                <div className="h-full rounded-full bg-secondary transition-all" style={{ width: `${percent}%` }} />
            </div>
        </div>
    )
}
